import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { ProfileQueryKey } from './queryKey';
export const useEnable2FA = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post('/api/user/Enable2FA', values)
        .then(res => res.data), {
        onSuccess: () => {
            queryClient.invalidateQueries([ProfileQueryKey.Profile]);
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { enable2FA: mutateAsync, isLoading };
};
